/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  CategoryResponseCollectionResponse,
  Condition,
  ErrorResponse,
  ProductOverviewResponseCollectionResponse,
  ProductResponseCollectionResponse,
  SaleMonthlyOverviewResponseCollectionResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Categories<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Categories
   * @name CategoriesList
   * @request GET:/Categories
   * @response `200` `CategoryResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  categoriesList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryResponseCollectionResponse, ErrorResponse>({
      path: `/Categories`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name GetCategoryProducts
   * @request GET:/Categories/{id}/Products
   * @response `200` `ProductResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCategoryProducts = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductResponseCollectionResponse, ErrorResponse>({
      path: `/Categories/${id}/Products`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name GetCategoryMonthlySalesWithinMonthsRange
   * @request GET:/Categories/{id}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCategoryMonthlySalesWithinMonthsRange = (
    id: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Categories/${id}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name GetWarehouseCategoryMonthlySalesWithinMonthsRange
   * @request GET:/Categories/{id}/Warehouses/{warehouseId}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getWarehouseCategoryMonthlySalesWithinMonthsRange = (
    id: number,
    warehouseId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Categories/${id}/Warehouses/${warehouseId}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name GetRegionCategoryMonthlySalesWithinMonthsRange
   * @request GET:/Categories/{id}/Regions/{regionId}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getRegionCategoryMonthlySalesWithinMonthsRange = (
    id: number,
    regionId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Categories/${id}/Regions/${regionId}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Categories
   * @name CategoryOverviews
   * @request GET:/Categories/{id}/Overviews
   * @response `200` `ProductOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  categoryOverviews = (id: number, params: RequestParams = {}) =>
    this.http.request<ProductOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Categories/${id}/Overviews`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
